import { IPaginatedResponse, TableWager } from "../interfaces";
import api from "./index";

export const wagerApi = api.injectEndpoints({
    endpoints: (builder) => ({
        findWager: builder.query<HallWager, number>({
            query: (hallId) => ({
                url: `hall/${hallId}/wager`,
                method: "get",
            }),
            transformResponse: (response: any) => response.data,
            providesTags: (_result, _error, hallId) => [{ type: "hall-wager", id: hallId }],
        }),
        findWagers: builder.query<IPaginatedResponse<TableWager[]>, FindWagersRequest>({
            query: (request) => ({
                url: `hall/${request.hall_id}/wager/${request.id}`,
                method: "get",
                params: {
                    page: request.page || 1
                },
            }),
            transformResponse: (response: any, meta: any) => {
                const headers = meta?.headers;
                const currentPage = Number(headers?.get("x-pagination-current-page")) || 1;
                const pageCount = Number(headers?.get("x-pagination-page-count")) || 1;
                const perPage = Number(headers?.get("x-pagination-per-page")) || 20;
                const totalCount = Number(headers?.get("x-pagination-total-count")) || 0;

                return {
                    items: Array.isArray(response) ? response : (response.data || response || []),
                    meta: {
                        currentPage,
                        pageCount,
                        perPage,
                        totalCount,
                    }
                };
            },
            providesTags: (_result, _error, request) => [{ type: "wager", id: request.hall_id }],
        }),
        cancelWager: builder.mutation<DefaultResponse<boolean>, BankCardRequestId>({
            query: request => ({ url: `hall/${request.hall_id}/wager/${request.id}/cancel`, method: "post" }),
            invalidatesTags: (_result, _error, request) => [{ type: "wager", id: request.hall_id }],
        }),
        findWagerHistory: builder.query<IPaginatedResponse<WagerHistoryItem[]>, WagerHistoryRequest>({
            query: (request) => ({
                url: `hall/${request.hall_id}/wager/${request.wager_id}/history`,
                method: "get",
                params: {
                    page: request.page || 1
                },
            }),
            transformResponse: (response: any, meta: any) => {
                const headers = meta?.headers;

                const currentPage = Number(headers?.get("x-pagination-current-page")) || 1;
                const pageCount = Number(headers?.get("x-pagination-page-count")) || 1;
                const perPage = Number(headers?.get("x-pagination-per-page")) || 20;
                const totalCount = Number(headers?.get("x-pagination-total-count")) || 0;

                return {
                    items: Array.isArray(response) ? response : (response.data || response || []),
                    meta: {
                        currentPage,
                        pageCount,
                        perPage,
                        totalCount,
                    }
                };
            },
        }),
    }),
});

export const { useFindWagerQuery, useFindWagersQuery, useCancelWagerMutation, useFindWagerHistoryQuery } = wagerApi;